// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"5cc1e697","149":"57313a78","255":"03225bdd","266":"eae6a479","333":"c5ff4741","726":"daf34459","817":"0db9811e"}[chunkId] + ".chunk.js";
};